import script from "./SelectionScreen.vue?vue&type=script&lang=js&setup=true"
export * from "./SelectionScreen.vue?vue&type=script&lang=js&setup=true"

import "./SelectionScreen.vue?vue&type=style&index=0&id=036a9c6c&lang=css"

const __exports__ = script;

export default __exports__